import React from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from '@lt/localization';
import Icon from '../../../../components/Icon';
import PriceChecker from '../../../../components/PriceChecker';
import { HOTEL_SEARCHER_REPEAT_DELAY } from '../../constants';

import styles from './searcher.module.css';

const SearcherTimer = ({ lastUpdated, isHotelOnly }) => {
  const { t } = useTranslation();
  if (!lastUpdated) return null;
  return (
    <PriceChecker
      className={styles.searcherTimerPriceChecker}
      lastUpdated={lastUpdated}
      timeout={HOTEL_SEARCHER_REPEAT_DELAY}
      text={t('hotel.searcherTimer', {
        context: isHotelOnly ? 'hotel' : 'package',
      })}
      fetchingText={t('hotel.searcherTimer', { context: 'update' })}
      icon={<Icon className={styles.searcherTimerIcon} type="clock" />}
    />
  );
};

SearcherTimer.defaultProps = {
  lastUpdated: null,
};

SearcherTimer.propTypes = {
  lastUpdated: PropTypes.number,
};

export default SearcherTimer;
